import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { STORE_USERNAME_KEY } from "@/app.constant";
import { Button, Footer, PabbitLogo } from "@/components";
import { SmsCaptcha } from "@/components/form";
import { useFormErrorsToast, useVisibilityToggle } from "@/hooks";
import { useGetVerifyCode, useSendVerifyCode } from "@/queries";
import { canSendCode, errorToast, recordCodeSendTime } from "@/shared";
import { checkTokenExpiration } from "@/shared/requests/auth";

import { ResendCode } from "../loginWithCode/components";

const LoginConfirmEmailPage = () => {
  const form = useForm();
  const navigate = useNavigate();
  const { watch, register, getValues, handleSubmit } = form;
  const { toastFormValueError } = useFormErrorsToast();

  const { mutateAsync: sendCode, isLoading: isCodeSending } = useSendVerifyCode();
  const { mutateAsync: getVerifyCode, isLoading: isCodeGeting } = useGetVerifyCode();

  const [isAllFieldFilled] = useVisibilityToggle(watch("code"));

  useEffect(() => {
    checkTokenExpiration().then(() => {
      navigate("/");
    });
  }, [navigate]);

  useEffect(() => {
    const email = window.localStorage.getItem(STORE_USERNAME_KEY);
    if (!email) {
      navigate("/login-email");
    }
  }, [navigate]);

  const handleLogin = async () => {
    const { code } = getValues();
    if (code?.trim().length !== 6) {
      errorToast("6桁のパスワードを入力してください");
      return;
    }
    sendCode({ code })
      .then(() => {
        window.localStorage.removeItem(STORE_USERNAME_KEY);
        history.replaceState(null, "", "/");
        history.go(0);
      })
      .catch((error) => {
        errorToast(error.message ?? error.toString());
      });
  };

  const resend = async () => {
    const email = window.localStorage.getItem(STORE_USERNAME_KEY) || "";
    if (!email) {
      errorToast("ユーザー情報が見つかりません");
      navigate("/login-email");
      return;
    }
    if (!canSendCode(email).canSend) {
      return;
    }
    recordCodeSendTime(email);
    try {
      await getVerifyCode({ phone: email, loginMethod: "email" });
    } catch (err) {
      errorToast(err instanceof Error ? err.message : String(err));
    }
  };

  return (
    <FormProvider {...form}>
      <div className="contents">
        <div className="m-9 flex-1">
          <PabbitLogo />
          <div className="mt-4">
            <p className=" font-semibold text-text-black">ワンタイムパスワードが送信されました</p>
            <p className=" mt-[6px] text-text-gray">ワンタイムパスワードを入力してください</p>
            <div className="mt-[38px]">
              <SmsCaptcha
                register={register("code", {
                  required: "6桁のパスワードを入力してください",
                })}
              />
            </div>
            <ResendCode onResend={resend} />
          </div>
          <div className="mt-6"></div>
          <Button
            className="w-full"
            size="large"
            onClick={handleSubmit(handleLogin, toastFormValueError)}
            loading={isCodeSending}
            disabled={!isAllFieldFilled || isCodeGeting}
          >
            ログイン
          </Button>
          <div className="mt-[40px]">
            <Button
              className="w-full"
              fill="outline"
              nativeType="button"
              size="large"
              onClick={() => navigate("/login-email")}
            >
              戻る
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    </FormProvider>
  );
};

export default LoginConfirmEmailPage;
